import { Evento } from './evento';

export class ElencoEventi {
    elenco:     Array<Evento>;
    page:       number;
    size:       number;
    maximumPages:   number;
    pageSize:   number;
    totalElements:   number;
}
